import { DatePicker, Space, Select, Table, message, Spin, Form, Image, Tooltip, Button, Divider, Input, Modal } from 'antd';
import dayjs from 'dayjs';
import constants from '../../constants/constants';
import { useContext, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import WebLinks from '../../api/WebLinks';
import Cookies from 'js-cookie';
import APIUtils from '../../api/APIUtils';
import moment from 'moment';
import { CommonContext } from '../../Context';
import { trackPageAccess } from '../../globalFunctions/GlobalFunctions';
const { RangePicker } = DatePicker;

const BoostOrdersFinance = (props) => {

	//Variable declaration
	const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
	const columns = [
		{
			title: 'Created On',
			dataIndex: 'createdOn',
			key: 'createdOn',
			render: (createdOn)=>{
				return moment(createdOn).format('YYYY-MM-D, h:mm a');
			}
		},
		{
			title: 'Order ID',
			dataIndex: 'id',
			key: 'id',
			sorter: (a, b) => a.id - b.id,
		},
		{
			title: 'ID',
			dataIndex: 'buyerId',
			key: 'buyerId',
			sorter: (a, b) => a.buyerId - b.buyerId,
		},
		{
			title: 'Name',
			dataIndex: 'reportName',
			key: 'reportName',
			sorter: (a, b) => a.reportName  - b.reportName,
		},
		{
			title: 'Description',
			dataIndex: 'description',
			key: 'description',
			sorter: (a, b) => a.description - b.description,
		},
		{
			title: 'No. of Products',
			dataIndex: 'numberOfProducts',
			key: 'numberOfProducts',
			align: 'center',
			sorter: (a, b) => a.numberOfProducts - b.numberOfProducts,
		},
		{
			title: 'Price Net',
			dataIndex: 'priceNet',
			key: 'priceNet',
			align: 'center',
			sorter: (a, b) => a.priceNet - b.priceNet,
			render: (text,record)=>{
				return <span>{record.priceCurrencySymbol+" "+text}</span>
			}
		},
		{
			title: 'Completed On',
			dataIndex: 'completedOn',
			key: 'completedOn',
			render: (completedOn)=>{
				return completedOn?moment(completedOn).format('YYYY-MM-D, h:mm a'):"In progress";
			}
		},
		{
			title: 'Invoiced On',
			dataIndex: 'invoicedOn',
			key: 'invoicedOn',
			render: (invoicedOn,record)=>{
				return invoicedOn?<><p>{moment(invoicedOn).format('YYYY-MM-D, h:mm a')}</p><p>ID: {record.invoiceId}</p></>:<Button type='link' onClick={()=>{setIsInvoiceModalOpen(true);setInvoiceId(record.id)}}>In progress</Button>;
			}
		},
	];
	const expandedTableColumns=[
		{
			key: 'emptyCol',
			width:'40%',
		},
		{
			title: 'Product Name',
			dataIndex: 'productName',
			key: 'productName',
			sorter: (a, b) => a.productName - b.productName,
		},
		{
			title: 'No. of Products',
			dataIndex: 'numberOfProducts',
			key: 'numberOfProducts',
			align: 'center',
			sorter: (a, b) => a.numberOfProducts - b.numberOfProducts,
			render: (text,record)=>{
				return <span>{"1"}</span>
			}
		},
		// {
		// 	title: 'Supplier Price',
		// 	dataIndex: 'supplierPrice',
		// 	key: 'supplierPrice',
		// 	align: 'center',
		// 	sorter: (a, b) => a.supplierPrice - b.supplierPrice,
		// 	render: (text,record)=>{
		// 		return <span>{record.buyerPriceCurrency+" "+text}</span>
		// 	}
		// },
		// {
		// 	title: 'Buyer Price',
		// 	dataIndex: 'buyerPrice',
		// 	key: 'buyerPrice',
		// 	align: 'center',
		// 	sorter: (a, b) => a.buyerPrice - b.buyerPrice,
		// 	render: (text,record)=>{
		// 		return <span>{record.buyerPriceCurrency+" "+text}</span>
		// 	}
		// },
		{
			title: 'Price Net',
			dataIndex: 'priceNet',
			key: 'priceNet',
			align: 'center',
			sorter: (a, b) => a.priceNet - b.priceNet,
			render: (text,record)=>{
				return <span>{record.priceCurrencySymbol+" "+text}</span>
			}
		},
		{
			title: 'Completed On',
			dataIndex: 'completedOn',
			key: 'completedOn',
			render: (completedOn)=>{
				return completedOn?moment(completedOn).format('YYYY-MM-D, h:mm a'):"In progress";
			}
		},
		{
			key: 'emptyCol2',
			width:'12%',
		},
		// {
		// 	title: 'Invoiced On',
		// 	dataIndex: 'invoicedOn',
		// 	key: 'invoicedOn',
		// 	render: (invoicedOn)=>{
		// 		return invoicedOn?moment(invoicedOn).format('YYYY-MM-D, h:mm a'):"In progress";
		// 	}
		// },
	];
	const [boostFinanceData, setBoostOrderFinanceData] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);
	const [rangePickerValue, setRangePickerValue] = useState([]);
	const [loader, setLoader] = useState(false);
	const [totalBoostCount, setTotalBoostCount] = useState(0);
	const [form] = Form.useForm();
  const [formInvoice] = Form.useForm();
  const [isInvoiceModalOpen,setIsInvoiceModalOpen]=useState(false);
	const [invoiceId,setInvoiceId]=useState("");

	useEffect(() => {
		const date1 = dayjs().startOf('month')
		const date2 = dayjs().endOf('month')
		form.setFieldsValue({
			rangePicker: [
				date1,
				date2,
			],
		});
		setRangePickerValue([
			date1.format(constants.MonthFormat),
			date2.format(constants.MonthFormat),
		]);
		GetBoostOrderFinanceData(1, 100,
			date1.format(constants.MonthFormat),
			date2.format(constants.MonthFormat));
	}, []);
	useEffect(() => {
    trackPageAccess(buyerId,window.location.href)
  }, []);


	//Functions
	//Function runs when range picker value is changed
	const RangePickerChanged = debounce((_, dateStrings) => {
		//props.changeDate(dateStrings);
		setRangePickerValue([
			dayjs(dateStrings[0], constants.MonthFormat),
			dayjs(dateStrings[1], constants.MonthFormat),
		]);
		GetBoostOrderFinanceData(currentPage, pageSize, dateStrings[0], dateStrings[1]);
	}, 500);

	//Function to Month report data
	const GetBoostOrderFinanceData = async (currentPage, pazeSize, startDate, endDate) => {
		setLoader(true);
		const response = await APIUtils.apiCall('GET', WebLinks.GetBoostFinanceData + buyerId 
		 + "&fromDate=" + startDate + "&toDate=" + endDate + "&limit=" + pazeSize + "&pageNo=" + currentPage
		);
		if (!response.isCatch && response.resultObj.statusCode === "2000") {
			setBoostOrderFinanceData(response.resultObj.data);
			setTotalBoostCount(response.resultObj.getCount);
			setLoader(false);
		} else {
			setBoostOrderFinanceData([]);
     	setTotalBoostCount(0);
			setLoader(false);
			message.error(response.resultObj.message);
		}
	}

	//Function on change of application table
	const onchangeApplicationTable = (pagination, filters, sorter) => {
		if (pagination) {
			if (pageSize !== pagination.pageSize) {
				setCurrentPage(1);
			} else {
				setCurrentPage(pagination?.current);
			}
			setPageSize(pagination?.pageSize);
			GetBoostOrderFinanceData(pagination?.current, pagination?.pageSize, rangePickerValue[0], rangePickerValue[1])
		}
	};

		//Funcion to render inner table
	const getBoostInnerTable = (tableData) => {
		return (
			<Table
				bordered
				size="small"
				columns={expandedTableColumns}
				dataSource={tableData}
				//showHeader={false}
				pagination={false}
				// pagination={{
				// 	defaultPageSize: 100,
				// 	pageSizeOptions: ["100", "250", "500"],
				// }}
			/>
		)
	}

  //Function to save invoice
    const saveInvoiceDetail=async(values)=>{
			setLoader(true);
			let payload;
			payload={
					id:invoiceId,
					invoicedOn:dayjs(values.invoiceddate).format('YYYY-MM-DD'),
					invoiceID:values.invoiceNumber,
			}
			const urlUpdate = WebLinks.UpdateInvoiceDetails;
			const responseDelete = await APIUtils.apiCall('PUT',urlUpdate,JSON.stringify(payload));
			if (!responseDelete.isCatch && responseDelete.resultObj.statusCode === "2000") {
				message.success(responseDelete.resultObj.message);
				formInvoice.resetFields();
				setIsInvoiceModalOpen(false);
				setLoader(false);
				GetBoostOrderFinanceData(currentPage, pageSize,  rangePickerValue[0], rangePickerValue[1]);
		} else {
				setLoader(false)
				message.error(responseDelete.resultObj.message)
		}
	}
	return (
		<>
			<Spin spinning={loader}>
      <div className='uppercase font-bold text-xl'>Multi Boost Orders Finance</div>
			<Divider className='my-3'/>
				<div>
					 <div className='flex flex-wrap gap-3 justify-between items-center mb-3'>
						<Form form={form}>
							<Form.Item name="rangePicker" className='mb-0'>
								<RangePicker picker="month"
									placeholder={["From", "To"]}
									onChange={RangePickerChanged}
									format={constants.MonthFormat} />
							</Form.Item>
						</Form>
					</div> 
					<div className='overflow-x-auto'>
						<Table
							columns={columns}
							dataSource={boostFinanceData}
							scroll={{
								x: 1000,
							}}
							onChange ={onchangeApplicationTable}
							sortDirections={['descend', 'ascend', 'descend']}
							pagination={{
								total: totalBoostCount,
								// showSizeChanger: true,
								// pageSizeOptions: ["25", "50", "100"],
								defaultPageSize: 100,
								current: currentPage,
							}}
							rowKey="id"
							expandable={{
								expandedRowRender: (record) => (<div>
									{getBoostInnerTable(record.boostOrderProducts)}
								</div>)
							}}
						/>
					</div>
				</div>
			</Spin>
      <Modal 
          title={"Invoice Update"} 
          open={isInvoiceModalOpen} 
          onCancel={()=>{setIsInvoiceModalOpen(false);formInvoice.resetFields()}}
          // footer={[]}
          okText={<span className="capitalize">Save</span>}
          onOk={() => formInvoice.submit()}
      >
          <Form
              name="basic"
              onFinish={saveInvoiceDetail}
              autoComplete="off"
              form={formInvoice}
          >
            <Form.Item
            label="Invoiced Date"
            name="invoiceddate"
						rules={[
							{
							required: true,
							message: 'Please select date!',
							},
					]}
            >
							<DatePicker 
							allowClear={false}   
							/>
            </Form.Item>
              <Form.Item
              label=" Invoice Number"
              name="invoiceNumber"
              rules={[
                  {
                  required: true,
                  message: 'Please enter invoice number!',
                  },
              ]}
              >
              <Input/>
              </Form.Item>
          </Form>
      </Modal>
		</>
	);
};

export default BoostOrdersFinance;